module.exports = __webpack_public_path__ + "static/media/down-caret.7f58c3c5.svg";